import React, { memo, useCallback } from 'react';
import classNames from 'classnames';

import Checkbox from '@zvuk-b2b/react-uikit/ui/Checkbox';

import type { TagFilterOptionProps } from '../../types';

import styles from '../../index.module.scss';

const TagFilterOption: React.FC<TagFilterOptionProps> = ({ isChecked, tag, testIds, onChange }) => {
  const handleChange = useCallback(
    (value: boolean) => {
      onChange(tag.id, value);
    },
    [onChange, tag.id]
  );

  return (
    <li
      className={classNames(styles.tagOption, {
        [styles.tagOptionChecked]: isChecked,
      })}
      data-testid={testIds.tagOption(tag.id)}>
      <Checkbox
        elementId={testIds.tagOptionCheckbox(tag.id)}
        buttonClassName={styles.tagCheckboxButton}
        labelClassName={styles.tagCheckboxLabel}
        isChecked={isChecked}
        onChange={handleChange}>
        {tag.title}
      </Checkbox>
    </li>
  );
};

export default memo(TagFilterOption);
